/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Youtube_Region_4Inputs */

const en_live_caption_youtube_region_4 = /** @type {(inputs: Live_Caption_Youtube_Region_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Center left`)
};

const fr_live_caption_youtube_region_4 = /** @type {(inputs: Live_Caption_Youtube_Region_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centre gauche`)
};

const de_live_caption_youtube_region_4 = /** @type {(inputs: Live_Caption_Youtube_Region_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitte links`)
};

const it_live_caption_youtube_region_4 = /** @type {(inputs: Live_Caption_Youtube_Region_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro sinistra`)
};

const ru_live_caption_youtube_region_4 = /** @type {(inputs: Live_Caption_Youtube_Region_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Центр слева`)
};

const es_live_caption_youtube_region_4 = /** @type {(inputs: Live_Caption_Youtube_Region_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`centro izquierda`)
};

const zh_cn2_live_caption_youtube_region_4 = /** @type {(inputs: Live_Caption_Youtube_Region_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`左中`)
};

const ja_live_caption_youtube_region_4 = /** @type {(inputs: Live_Caption_Youtube_Region_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中央左`)
};

const hi_live_caption_youtube_region_4 = /** @type {(inputs: Live_Caption_Youtube_Region_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`केंद्र बाएँ`)
};

const pt_pt2_live_caption_youtube_region_4 = /** @type {(inputs: Live_Caption_Youtube_Region_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro esquerdo`)
};

/**
* | output |
* | --- |
* | "Center left" |
*
* @param {Live_Caption_Youtube_Region_4Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_youtube_region_4 = /** @type {((inputs?: Live_Caption_Youtube_Region_4Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Youtube_Region_4Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_youtube_region_4(inputs)
	if (locale === "de") return de_live_caption_youtube_region_4(inputs)
	if (locale === "it") return it_live_caption_youtube_region_4(inputs)
	if (locale === "ru") return ru_live_caption_youtube_region_4(inputs)
	if (locale === "es") return es_live_caption_youtube_region_4(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_youtube_region_4(inputs)
	if (locale === "ja") return ja_live_caption_youtube_region_4(inputs)
	if (locale === "hi") return hi_live_caption_youtube_region_4(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_youtube_region_4(inputs)
	return en_live_caption_youtube_region_4(inputs)
});